import { render, staticRenderFns } from "./vFormHEADLINE.vue?vue&type=template&id=f560f548&scoped=true&"
import script from "./vFormHEADLINE.vue?vue&type=script&lang=js&"
export * from "./vFormHEADLINE.vue?vue&type=script&lang=js&"
import style0 from "./vFormHEADLINE.vue?vue&type=style&index=0&id=f560f548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f560f548",
  null
  
)

export default component.exports